import React from "react";
import { Dialog, type DialogAction } from "../Dialog";

export interface AlertProps {
  /**
   * Whether the alert is open
   */
  isOpen: boolean;
  /**
   * Callback when the alert is closed
   */
  onClose: () => void;
  /**
   * Alert title
   */
  title: string;
  /**
   * Alert message/content
   */
  message: React.ReactNode;
  /**
   * Label for the confirm button
   * @default "OK"
   */
  confirmLabel?: string;
  /**
   * Variant for the confirm button
   * @default "primary"
   */
  confirmVariant?: DialogAction["variant"];
  /**
   * Maximum width of the alert dialog
   * @default "400px"
   */
  maxWidth?: string;
  /**
   * Minimum width of the alert dialog (desktop only)
   * @default "320px"
   */
  minWidth?: string;
}

/**
 * Alert
 *
 * A simple alert dialog with a single action button.
 * Use for informational messages that require acknowledgment.
 */
export function Alert({
  isOpen,
  onClose,
  title,
  message,
  confirmLabel = "OK",
  confirmVariant = "primary",
  maxWidth = "400px",
  minWidth = "320px",
}: AlertProps) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      maxWidth={maxWidth}
      minWidth={minWidth}
      primaryAction={{
        label: confirmLabel,
        onPress: onClose,
        variant: confirmVariant,
      }}
    >
      <div className="text-text-body">{message}</div>
    </Dialog>
  );
}
